import styled from 'styled-components';
import MyInfoImg from './MyInfoImg';

const MyInfoBoxWrap = styled.div`
    border: 0.063rem solid #DDDDDD;
    padding: 1.188rem 1.25rem 0.938rem 1.25rem;
    margin-bottom: 1.875rem;
    margin-top: 1rem;

    ${MyInfoImg} {
        margin-bottom: 0.5rem;
    }
`;

export default MyInfoBoxWrap;